import React from 'react';

import { IPromotionItemInput } from '@/interface/promotion';

import List from './list';

export const CustomPromotionIndex: React.FC<{
  onChange: (data: IPromotionItemInput[]) => void;
  value: IPromotionItemInput[];
}> = (props) => {
  const { value, onChange } = props;

  const handleChange = (data: IPromotionItemInput) => {
    const hasValue = value?.some(e => e?.id === data?.id);
    let tempValue = value;
    tempValue = value?.map((e) => {
      if (e?.id === data?.id) {
        return data;
      }
      return e;
    }) || [];
    onChange(hasValue ? tempValue : tempValue.concat([data]));
  };

  const handelMove = (id: string) => {
    const index = value?.findIndex(e => e?.id === id);
    if (index > -1) {
      const tempValue = [...value];
      tempValue.splice(index, 1);
      onChange(tempValue);
    }
  };

  const handleSort = (data: IPromotionItemInput[]) => {
    onChange(data);
  };

  return (
    <div>
      <List
        data={value}
        onChange={handleChange}
        onMove={handelMove}
        onSort={handleSort}
      />
    </div>
  );
};
